export const COMMON_DOWNLOAD_IMAGE_SIZES = {
	SIZE_32: {
		WIDTH: 32,
		HEIGHT: 32,
	},
	SIZE_48: {
		WIDTH: 48,
		HEIGHT: 48,
	},
	SIZE_64: {
		WIDTH: 64,
		HEIGHT: 64,
	},
	SIZE_80: {
		WIDTH: 80,
		HEIGHT: 80,
	},
	SIZE_96: {
		WIDTH: 96,
		HEIGHT: 96,
	},
	SIZE_160: {
		WIDTH: 160,
		HEIGHT: 160,
	},
	SIZE_192: {
		WIDTH: 192,
		HEIGHT: 192,
	},
	SIZE_208: {
		WIDTH: 208,
		HEIGHT: 208,
	},
	SIZE_416: {
		WIDTH: 416,
		HEIGHT: 416,
	},
	SIZE_20_NO_WIDTH: {
		HEIGHT: 20,
	},
	SIZE_32_NO_WIDTH: {
		HEIGHT: 32,
	},
	SIZE_40_NO_WIDTH: {
		HEIGHT: 40,
	},
	SIZE_64_NO_WIDTH: {
		HEIGHT: 64,
	},
	SIZE_80_NO_WIDTH: {
		HEIGHT: 80,
	},
	SIZE_120_NO_WIDTH: {
		HEIGHT: 120,
	},
	SIZE_256_NO_WIDTH: {
		HEIGHT: 256,
	},
	SIZE_256_NO_HEIGHT: {
		WIDTH: 256,
	},
	SIZE_512_NO_HEIGHT: {
		WIDTH: 512,
	},
	SIZE_640_NO_WIDTH: {
		HEIGHT: 640,
	},
};
